import { createReducer } from 'redux-act';
import {
  AVAILABILITY_CHECK_REQUEST,
  AVAILABILITY_CHECK_SUCCESS,
  AVAILABILITY_CHECK_FAILURE,
  AVAILABILITY_CLEAR,
  SLOT_CREATE_INIT,
  SLOT_CREATE_SUCCESS,
  SLOT_CREATE_FAIL,
  SLOT_UPDATE_INIT,
  SLOT_UPDATE_SUCCESS,
  SLOT_UPDATE_FAIL,
  SLOT_DELETE_INIT,
  SLOT_DELETE_SUCCESS,
  SLOT_DELETE_FAIL,
  SLOT_MEDIA_ASSIGN_INIT,
  SLOT_MEDIA_ASSIGN_SUCCESS,
  SLOT_MEDIA_ASSIGN_FAIL,
  SLOT_MEDIA_REMOVE_INIT,
  SLOT_MEDIA_REMOVE_SUCCESS,
  SLOT_MEDIA_REMOVE_FAIL,
} from 'state/actions/slot';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export const slotReducer = createReducer(
  {
    [AVAILABILITY_CHECK_REQUEST]: (state) => ({ ...state, loading: true, error: null }),
    [AVAILABILITY_CHECK_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      data: payload,
      error: null,
    }),
    [AVAILABILITY_CHECK_FAILURE]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload,
    }),
    [AVAILABILITY_CLEAR]: () => initialState,

    [SLOT_CREATE_INIT]: (state) => ({ ...state, loading: true }),
    [SLOT_CREATE_SUCCESS]: (state) => ({ ...state, loading: false, error: null }),
    [SLOT_CREATE_FAIL]: (state, { error }) => ({ ...state, loading: false, error }),

    [SLOT_UPDATE_INIT]: (state) => ({ ...state, loading: true }),
    [SLOT_UPDATE_SUCCESS]: (state) => ({ ...state, loading: false, error: null }),
    [SLOT_UPDATE_FAIL]: (state, { error }) => ({ ...state, loading: false, error }),

    [SLOT_DELETE_INIT]: (state) => ({ ...state, loading: true }),
    [SLOT_DELETE_SUCCESS]: (state) => ({ ...state, loading: false, error: null }),
    [SLOT_DELETE_FAIL]: (state, { error }) => ({ ...state, loading: false, error }),

    [SLOT_MEDIA_ASSIGN_INIT]: (state) => ({ ...state, loading: true }),
    [SLOT_MEDIA_ASSIGN_SUCCESS]: (state) => ({ ...state, loading: false, error: null }),
    [SLOT_MEDIA_ASSIGN_FAIL]: (state, { error }) => ({ ...state, loading: false, error }),

    [SLOT_MEDIA_REMOVE_INIT]: (state) => ({ ...state, loading: true }),
    [SLOT_MEDIA_REMOVE_SUCCESS]: (state) => ({ ...state, loading: false, error: null }),
    [SLOT_MEDIA_REMOVE_FAIL]: (state, { error }) => ({ ...state, loading: false, error }),
  },
  initialState
);
